import React, { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AdminFormSection } from '@ui';
import { TXUserFormBase } from '@lp/features/admin/forms/TXUserFormBase/TXUserFormBase';
import { TMDXFile } from '@/api/apis/files';
import { TXUserBaseFormType } from '@/types/customer';
import { getFullName } from '@/utils/helpers';
import { TXUserActiveStatus } from './TXUserActiveStatus';

type Props = {
  isReadOnly?: boolean;
  isEditMode: boolean;
};

export const TXUserDetailsSection = React.memo(({ isReadOnly = false, isEditMode }: Props) => {
  const { control, setValue } = useFormContext<TXUserBaseFormType>();

  const photoPath = useWatch({ control, name: 'photoPath' });
  const firstName = useWatch({ control, name: 'firstName' });
  const lastName = useWatch({ control, name: 'lastName' });

  const onImageChange = useCallback(
    (file: TMDXFile) => {
      setValue('photo', file, { shouldDirty: true });
    },
    [setValue],
  );

  return (
    <AdminFormSection
      title="TX User Details"
      withAvatar
      imageUrl={photoPath}
      isReadOnly={isReadOnly}
      onImageChange={onImageChange}
      type="user"
      name={getFullName(firstName, lastName)}
    >
      <TXUserFormBase isReadOnly={isReadOnly} />
      {isEditMode && <TXUserActiveStatus isReadOnly={isReadOnly} />}
    </AdminFormSection>
  );
});

TXUserDetailsSection.displayName = 'TXUserDetailsSection';
